import ConfirmEmailScreen from 'features/myVaro/screens/PersonalDetails/ChangeEmail/ConfirmEmail/ConfirmEmailScreen';
import React from 'react';

export default function ConfirmEmailPage() {
  return <ConfirmEmailScreen />;
}
